import React from "react";
import { FiArrowDownLeft, FiArrowUpLeft } from "react-icons/fi";
import Girl from "../Assets/Images/Dashboard/girl-vector.svg";
import "../Assets/Css/TileWithImg.scss";

const TileWithImg = (props) => {
  const renderPercentage = (percentage) => {
    const roundedPercentage = Math.round(Math.abs(percentage));

    if (percentage > 0) {
      return (
        <span className="text-color-green">
          <FiArrowUpLeft></FiArrowUpLeft>
          {roundedPercentage}%
        </span>
      );
    } else if (percentage < 0) {
      return (
        <span className="text-color-red">
          <FiArrowDownLeft></FiArrowDownLeft>
          {roundedPercentage}%
        </span>
      );
    }

    // Handle the case where percentage is 0
    return <span>{roundedPercentage}%</span>;
  };

  return (
    <div className="tiles-with-image">
      <div className="tiles-container">
        <div className="tiles-content py-3">
          <div className="tiles-statistics">
            <div className="custum-content mb-4">
              <p className="mb-0">Monthly Avg. Income </p>
              <span className="normal-text">
                ₹{Math.round(props.avgIncomeAmount)}
              </span>{" "}
              {renderPercentage(props.avgIncomePercentage)}
            </div>

            <div className="custum-content">
              <p className="mb-0">Monthly Avg. Spent </p>
              <span className="normal-text">
                ₹{Math.round(props.avgSpentAmount)}
              </span>{" "}
              {renderPercentage(props.avgSpentPercentage)}
            </div>
          </div>
        </div>
        <div className="tiles-chart">
          <img src={Girl} alt="girld" />
        </div>
      </div>
    </div>
  );
};

export default TileWithImg;
